module.exports = __webpack_public_path__ + "img/capa-padrao-livro.341c9910.png";